// import Backbone from 'backbone';
import tmpl from '../templates';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var OptionDetailView = Backbone.View.extend( {

    tagName: 'li',
    className: 'option-item group-item',
    template: _.template( tmpl.optionDetail ),

    events: {
        'click': 'handleSelect'
    },

    initialize: function () {
        this.listenTo( this.model, 'change', function () {
            this.render();
            app.validator.trigger( 'clear:validation' );
        } );
    },

    render: function () {
        this.$el.html( this.template( this.model.attributes ) );
        this.$span = this.$el.find( 'span' );

        if ( this.model.get( 'optionColors' ).length ) {
            this.setOptionColor( this.model.get( 'optionColors' ) );
        }

        this.toggleSelected();
        this.toggleAvailable();
        this.toggleDisabled();

        return this;
    },

    setOptionColor: function ( colors ) {
        if ( colors.length ) {
            // if colors contain white, apply a light border through indicator-reverse class
            var indicatorClass = !colors.join( ' ' ).match( /fff|white/ )
                ? 'indicator'
                : 'indicator-reverse',
                indicator = $( '<i/>' ).addClass( indicatorClass );

            indicator.css( {
                borderColor: [
                    colors[0],
                    'transparent',
                    'transparent',
                    colors[colors.length > 1
                        ? 1
                        : 0]
                ].join( ' ' )
                // if more the one colors, display 2 colors as diagonal halves
                //                            ? [ colors[0], 'transparent', 'transparent', colors[1] ].join( ' ' )
                // else display solid color
                //                            : colors[0]
            } );

            this.$span.append( indicator );
        }
    },

    handleSelect: function () {
        // ignore disabled items
        if ( !!this.model.get( 'disabled' ) ) {
            return;
        }

        this.model.select();
    },

    doSelect: function () {
        this.model.select();
    },

    toggleSelected: function () {
        this.$el.toggleClass( 'selected', this.model.get( 'selected' ) );
    },

    toggleAvailable: function () {
        var isAvailable = this.model.get( 'available' );
        var msg = upi.i18n.getTextFromKey('lbl-optionNotAvailableSection');
        this.$el.toggleClass( 'off', !isAvailable );
        this.toggleTooltip( isAvailable, msg );
    },

    toggleDisabled: function () {
        // todo: refactor toggleTooltip to allow for better messaging when item is disabled
        var isDisabled = this.model.get( 'disabled' );
        this.$el.toggleClass( 'disabled', isDisabled );
        this.toggleTooltip( !isDisabled );
    },

    toggleTooltip: function ( isAvailable, msg ) {
        const msgDefault = upi.i18n.getTextFromKey('lbl-optionNotAvailable');
        
        this.$el.data( 'base-tooltip', this.$span.attr( 'data-tooltip' ) || '' );
        this.$span.attr( 'data-tooltip', (!isAvailable)
            ? msg || msgDefault
            : this.$el.data( 'base-tooltip' ) );
    },

    /**
     * Garbage Collection
     */
    close: function () {
        this.undelegateEvents();
        this.stopListening( this.model );
        this.remove();
    }

} );

export default OptionDetailView;
